import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAuthenticated:
        localStorage.getItem("isLoggedIn") === "true" ||
        sessionStorage.getItem("isLoggedIn") === "true",
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginUser: (state, action) => {
            const rememberMe = action.payload;
            state.isAuthenticated = true;

            if (rememberMe) {
                localStorage.setItem("isLoggedIn", "true");
            } else {
                sessionStorage.setItem("isLoggedIn", "true");
                localStorage.removeItem("isLoggedIn");
            }
        },
        logoutUser: (state) => {
            state.isAuthenticated = false;
            localStorage.removeItem("isLoggedIn");
            sessionStorage.removeItem("isLoggedIn");
        },
    },
});

export const { loginUser, logoutUser } = authSlice.actions;
export default authSlice.reducer;
